import { apiClient } from '../../lib/api-client';
import type { DischargeSummary, MrdGeneratePayload, MrdGenerateResult, MrdSummary } from './types';

export const fetchMrdSummary = async (date: string) => {
  const response = await apiClient.get<{ success: true; data: MrdSummary }>('/mrd/summary', { params: { date } });
  return response.data.data;
};

export const fetchDischargeSummary = async () => {
  const response = await apiClient.get<{ success: true; data: DischargeSummary }>('/mrd/discharge-summary');
  return response.data.data;
};

export const generateMrdEntry = async (payload: MrdGeneratePayload) => {
  const response = await apiClient.put<{ success: true; data: MrdGenerateResult }>('/mrd/entries', payload);
  return response.data.data;
};
